module.exports = "/images/img-googleplay.png?b5480f8b7d4bdaaf0e93c239c0f15204";